import { useMutation, useQuery } from '@apollo/client';
import { useCustomSnackbar } from '@procureai/ui-mui';
import { useCallback, useMemo } from 'react';

import { useChatSession } from '~/modules';

import { INTAKE_QUOTE_STEP_CREATE_MUTATION } from './IntakeQuoteStep.mutation.gql';
import { INTAKE_QUOTE_QUERY } from './IntakeQuoteStep.query';
import { IntakeQuoteFormData } from './IntakeQuoteStep.schema.ts';
import { toFormSchemaData, toGraphqlFormat } from './IntakeQuoteStep.utils';

export const useQuoteStep = () => {
  const session = useChatSession();
  const { onError } = useCustomSnackbar();

  const { data: queriedData } = useQuery(INTAKE_QUOTE_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: session,
  });

  const [next, { loading }] = useMutation(INTAKE_QUOTE_STEP_CREATE_MUTATION, {
    onError,
  });

  const data = useMemo(
    () => ({
      quote: toFormSchemaData(queriedData?.sevenbridges.chatSession.quote),
      commodityGroupId: queriedData?.sevenbridges.chatSession.request?.commodityGroupId,
    }),
    [queriedData],
  );

  const submit = useCallback(
    async (formData: IntakeQuoteFormData) => {
      await next({
        variables: toGraphqlFormat(session.id, formData),
      });
    },
    [next, session.id],
  );

  return {
    submit,
    isSubmitting: loading,
    data,
  };
};
